import {
  SET_QUIZ_ID,
  SET_QUIZ,
  SET_QUIZ_DURATION,
  SET_ALL_QUESTIONS,
  SET_EASY_QUESTIONS,
  SET_MEDIUM_QUESITONS,
  SET_HARD_QUESTIONS,
  SET_TECKET,
  SET_DURATION,
  SET_LEADER_BOARD_DATA,
  ANSWERED_QUESTIONS_COUNT,
  SET_MAX_ANSWER,
  LAST_QUESTION_ID,
  RENDER_LOADING,
  FINALIZE_QUIZ,
  SET_FINALIZE_REPORT,
  LOADING_FETCH_LB_DATA,
  LOADING_QUIZ_REQUESTS,
  SET_QUESTION_DATA,
  QUESTION_ANSWER,
  QUESTION_ANSWERED,
  SHOW_FINALIZE_MODAL,
  SHOW_CHEAT_MODAL,
  SET_WRONG_ANSWERS,
  SET_RIGHT_ANSWER,
  SET_SHOW_WORD_GAME_HINT_MODAL,
} from "../../constants/ActionTypes";

export const setLoadingQuizRequests = (loading) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_QUIZ_REQUESTS,
      payload: loading,
    });
  };
};

export const setQuizId = (quizId) => {
  return (dispatch) => {
    dispatch({
      type: SET_QUIZ_ID,
      payload: quizId,
    });
  };
};
export const setQuiz = (quiz) => {
  return (dispatch) => {
    dispatch({
      type: SET_QUIZ,
      payload: quiz,
    });
  };
};
export const setQuestionAnswer = (question) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION_ANSWER,
      payload: question,
    });
  };
};
export const setCurrentQuestion = (question) => {
  return (dispatch) => {
    dispatch({
      type: SET_QUESTION_DATA,
      payload: question,
    });
  };
};
export const setQuizDuration = (quizDuration) => {
  return (dispatch) => {
    dispatch({
      type: SET_QUIZ_DURATION,
      payload: quizDuration,
    });
  };
};
export const setAllQuestions = (allQuestions) => {
  return (dispatch) => {
    dispatch({
      type: SET_ALL_QUESTIONS,
      payload: allQuestions,
    });
  };
};
export const setEasyQuestions = (easyQuestions) => {
  return (dispatch) => {
    dispatch({
      type: SET_EASY_QUESTIONS,
      payload: easyQuestions,
    });
  };
};
export const setMediumQuestions = (mediumQuestions) => {
  return (dispatch) => {
    dispatch({
      type: SET_MEDIUM_QUESITONS,
      payload: mediumQuestions,
    });
  };
};
export const setHardQuestions = (hardQuestions) => {
  return (dispatch) => {
    dispatch({
      type: SET_HARD_QUESTIONS,
      payload: hardQuestions,
    });
  };
};
export const setTicket = (ticket) => {
  return (dispatch) => {
    dispatch({
      type: SET_TECKET,
      payload: ticket,
    });
  };
};
export const setDuration = (duration) => {
  return (dispatch) => {
    dispatch({
      type: SET_DURATION,
      payload: duration,
    });
  };
};
export const setLBFetchLoading = (loading) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_FETCH_LB_DATA,
      payload: loading,
    });
  };
};
export const setLeaderBoardData = (leaderBoardData) => {
  return (dispatch) => {
    dispatch({
      type: SET_LEADER_BOARD_DATA,
      payload: leaderBoardData,
    });
  };
};
export const setAnsweredQuestoinsCount = (count) => {
  return (dispatch) => {
    dispatch({
      type: ANSWERED_QUESTIONS_COUNT,
      payload: count,
    });
  };
};
export const setMaxAnswer = (maxAnswer) => {
  return (dispatch) => {
    dispatch({
      type: SET_MAX_ANSWER,
      payload: maxAnswer,
    });
  };
};
export const setLastQuestionId = (id) => {
  return (dispatch) => {
    dispatch({
      type: LAST_QUESTION_ID,
      payload: id,
    });
  };
};
export const setRenderLoading = (loading) => {
  return (dispatch) => {
    dispatch({
      type: RENDER_LOADING,
      payload: loading,
    });
  };
};
export const setfinalizeQuiz = (finalize) => {
  return (dispatch) => {
    dispatch({
      type: FINALIZE_QUIZ,
      payload: finalize,
    });
  };
};
export const setfinalizeReport = (report) => {
  return (dispatch) => {
    dispatch({
      type: SET_FINALIZE_REPORT,
      payload: report,
    });
  };
};

export const setQuestionAnswered = (answeredQuestion) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION_ANSWERED,
      payload: answeredQuestion,
    });
  };
};

export const setShowFinalizeModal = (show) => {
  return (dispatch) => {
    dispatch({
      type: SHOW_FINALIZE_MODAL,
      payload: show,
    });
  };
};

export const setShowCheatModal = (show) => {
  return (dispatch) => {
    dispatch({
      type: SHOW_CHEAT_MODAL,
      payload: show,
    });
  };
};

export const setWrongAnswers = (wrongAnswers) => {
  return (dispatch) => {
    dispatch({
      type: SET_WRONG_ANSWERS,
      payload: wrongAnswers,
    });
  };
};

export const setRightAnswer = (rightAnswer) => {
  return (dispatch) => {
    dispatch({
      type: SET_RIGHT_ANSWER,
      payload: rightAnswer,
    });
  };
};

export const setShowWordGameHintModal = (show) => {
  return (dispatch) => {
    dispatch({
      type: SET_SHOW_WORD_GAME_HINT_MODAL,
      payload: show,
    });
  };
};